import axios from 'axios';

export const submitEarnEvent = async (earnEvent) => {
    const loyaltyNumber = new URLSearchParams(window.location.search).get("param2");
    
    if (loyaltyNumber !== null) {
        const url = '/om-api/rewards-tracking/registerRewardsEarnEvent';
        const requestPayload = buildAPIRequest(loyaltyNumber, earnEvent);
        
        try {
            await axios.post(url, requestPayload, {
                headers: { 'Content-Type': 'application/json' }
            });
        } catch (error) {
            // Suppress error but log for debugging
            console.warn("submitEarnEvent failed:", error?.response?.data || error.message);
        }
    }
};

const buildAPIRequest = (loyaltyNumber, earnEvent) => {
    return {
        LoyaltyNumber: loyaltyNumber,
        EventCode: earnEvent,
        CompletionDateTime: new Date().toISOString(),
        PartnerID: "OMDigital",
        CLM_Program: "REWARDS",
    };
};

export const earnEventMap = {
    savings: "CalcSAV",
    educationSavings: "CalcEDU",
    retirementSaving: "CalcRET",
    incomeTax: "CalcINCTX",
    debtRepayments: "CalcDBTR",
    budgetBenchmarking: "CalcBUDG"
};